import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import theme from "../../../assets/theme";
import { CaseHeader } from "./components/CaseHeader";
import { CaseTabStrip } from "./components/CaseTabStrip";
import DocumentsSection from "./HearingBundles/DocumentsLanding";
import CaseDetails from "./components/CaseDetails";
import HearingsTab from "./components/HearingsTab";
import CaseDiscovery from "./components/CaseDiscovery";
import AgentListModal from "../AgentListModal/AgentListDrawer";
import ClaimItemsListModal from "../ClaimItemsListModal/index";
import HearingTimeline from "../HearingTimeLine";

const Index = ({
  isActionsDisabled,
  isViewAction,
  state,
  setState,
  caseDetails,
  pendingRegistrationFee,
  id,
  MTRef,
  partyList,
  setTriggerCaseCall,
  docUploadModal,
  setDocUploadModal,
  setFields,
  tab,
  setTab,
  view,
  setView,
  type,
  statusCheck,
  activeDoc,
  setActiveDoc,

  items,
  selectedIndex,
  isMediation,
  resolutionKind,
  status,
  currentStateKey,
  meetingDetail,

  stopTranscriptionAlert,
  startTranscription,
  setRefreshStatus,
  generateRTMPLink,
  setSettingsModal,
  setMeetingDetail,
  isActionsCmDisabled,
  currentState,
  addCaseManager = () => { },
  removeCaseManager = () => { },
  removeJoinCm = () => { },
  setOpenAssignCaseManager
}) => {
  const [opendrawer, setOpenDrawer] = useState(false);
  const [openHearing, setOpenHearing] = useState(false);
  const [claimModal, setClaimModal] = useState(false);
  const [trackingModal, setTrackingModal] = useState({ state: false });
  const [timelineModal, setTimelineModal] = useState({ state: false });
  const [opendrawerClaim, setOpenDrawerClaim] = useState(false);
  const [trigger, setTrigger] = useState(false);

  const openTrackingModal = () => {
    setTrackingModal({
      state: true,
      trackingData: caseDetails?.trackingNumbers,
    });
  };

  return (
    <>
      {activeDoc ? null : (
        <StickyHeader>
          <CaseHeader
            {...{
              caseDetails,
              status,
              setFields,
              setOpenHearing,
              MTRef,
            }}
          />
          <CaseTabStrip
            active={tab}
            onChange={setTab}
            {...{ caseDetails, view, setView }}
          />
        </StickyHeader>
      )}

      {tab.key === "sheet" ? (
        <>
          <CaseDetails
            caseObj={caseDetails}
            {...{
              setOpenDrawer,
              items,
              resolutionKind,
              selectedIndex,
              isMediation,
              status,
              currentStateKey,
              openTrackingModal,
              setOpenHearing,
              setTimelineModal,
              setFields,
              partyList,
              isActionsDisabled,
              caseDetails,
              openHearing,
              meetingDetail,
              isActionsCmDisabled,
              currentState,
              addCaseManager,
              removeCaseManager,
              removeJoinCm,
              setOpenAssignCaseManager
            }}
          />
        </>
      ) : tab.key === "documents" ? (
        <DocumentsSection
          {...{
            caseDetails,
            isActionsDisabled,
            view,
            setView,
            trigger,
            setTrigger,
          }}
          onChange={setTab}
          id={id}
        />
      ) : tab.key === "payments" ? (
        <></>
      ) : // <PaymentsTab open={true} setOpen={() => {}} caseId={id} id={id} />
        tab.key === "discovery" ? (
          <CaseDiscovery />
        ) : (
          caseDetails?.resolutionKind !== "negotiation" && (
            <HearingsTab
              open={true}
              setOpen={() => { }}
              caseId={id}
              id={id}
              type={caseDetails?.resolutionKind}
              {...{
                isActionsDisabled,
                caseDetails,
                tab,
                MTRef,
                statusCheck,
                stopTranscriptionAlert,
                startTranscription,
                setRefreshStatus,
                generateRTMPLink,
                state,
                meetingDetail,
                setState,
                setSettingsModal,
                setMeetingDetail,
              }}
            />
          )
        )}

      <AgentListModal {...{ opendrawer, setOpenDrawer, MTRef, partyList }} />
      <ClaimItemsListModal
        {...{
          opendrawerClaim,
          setOpenDrawerClaim,
          MTRef,
          displayAuthUrl: false,
        }}
        caseDetails={caseDetails}
      />
      {timelineModal?.state && (
        <HearingTimeline {...{ timelineModal, setTimelineModal }} />
      )}
    </>
  );
};

export default Index;

export const fadeIn = keyframes`from { opacity: 0 } to { opacity: 1 }`;
export const slideUp = keyframes`
 from { opacity: 0; transform: translateY(20px) scale(0.98) }
 to { opacity: 1; transform: translateY(0) scale(1) }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: ${fadeIn} 0.2s ease;
`;

export const ModalBox = styled.div`
  background: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 460px;
  box-shadow:
    0 24px 64px rgba(41, 52, 97, 0.16),
    0 4px 16px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(226, 232, 240, 0.8);
  overflow: hidden;
  animation: ${slideUp} 0.28s cubic-bezier(0.34, 1.3, 0.64, 1);
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 22px 24px 18px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 1px solid #e2e8f0;
`;

export const ModalTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const ModalTitle = styled.h2`
  font-size: 16px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: #293461;
  margin: 0 0 2px;
  letter-spacing: -0.2px;
`;

export const ModalSub = styled.p`
  font-size: 12px;
  color: #949ab0;
  margin: 0;
  font-weight: 400;
`;

export const ModalBody = styled.div`
  padding: 22px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const FieldLabel = styled.label`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #949ab0;
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const CurrencyHint = styled.p`
  font-size: 11.5px;
  color: #949ab0;
  margin: 0;
  font-weight: 500;
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: #f8f9fa;
`;

export const SaveBtn = styled.button`
  padding: 10px 22px;
  background: #00838c;
  color: #ffffff;
  border: none;
  border-radius: 9px;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 150px;
  justify-content: center;
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const AgentLink = styled.button`
  background: none;
  border: none;
  color: #00838c;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 0;
  transition: all 0.2s ease;
  text-align: left;
  &:hover {
    text-decoration: underline;
  }
`;

const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;
